// extracted by mini-css-extract-plugin
module.exports = {"root":"_4c35804","content":"_7ffd4ed","heading":"_f91584c","description":"_dbd5ca9","linkButton":"_4e67dbd"};